import React from "react";
import { ChevronRightRounded } from "@mui/icons-material";
const SUB_MENU_CONTAINER = ({name}) => {
  return (
    <div className="subMenu_container">
      <h3>{name}</h3>
      <div className="view_all">
        <p>View All</p>
        <li>
          <ChevronRightRounded />
        </li>
      </div>
    </div>
  );
};

export default SUB_MENU_CONTAINER;
